module.exports = __webpack_public_path__ + "img/arrow-right.f67e1c3b.svg";